import { configureStore, createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'

import { api } from './api'
import { switchCompany } from './features/sessionActions'
import { logout } from './features/userSlice'
import { rootReducer } from './root-reducer'

// Cached queries belong to the previous user/company. Reset through the action
// (not the root reducer) so RTK Query's middleware also drops its subscriptions.
const sessionListener = createListenerMiddleware()
sessionListener.startListening({
  matcher: isAnyOf(logout, switchCompany),
  effect: (_, listenerApi) => {
    listenerApi.dispatch(api.util.resetApiState())
  },
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: false,
    })
      .prepend(sessionListener.middleware)
      .concat([api?.middleware]),
})
